import $ from 'jquery';

/* global x5script, google */

class GoogleMaps {
  constructor() {
    this.googleMapsJs = document.querySelectorAll('.js-google-map-js');
    this.googleMapsIframe = document.querySelectorAll('.js-google-map-iframe');

    if (this.googleMapsJs.length) {
      $.getScript(
        `https://maps.googleapis.com/maps/api/js?key=${x5script.mapsAPIkey}`,
        (script, status) => {
          if (status === 'success') {
            Array.prototype.forEach.call(this.googleMapsJs, map => {
              GoogleMaps.createNewMap(map);
            });
          }
        },
      );
    }

    if (this.googleMapsIframe.length) {
      this.googleMapsIframe.forEach(map => {
        GoogleMaps.createIframeMap(map);
      });
    }
  }

  static createIframeMap(mapElement) {
    const self = $(mapElement);
    const mapAddress = self.attr('data-map-address');
    const mapZoom = parseFloat(self.attr('data-map-zoom')) || 16;
    const mapLat = parseFloat(self.attr('data-map-lat'));
    const mapLng = parseFloat(self.attr('data-map-lng'));

    if (!mapAddress.trim().length || typeof mapAddress === 'undefined') {
      self.hide();
      return;
    }

    const hasLatLng =
      typeof mapLat !== 'undefined' && typeof mapLng !== 'undefined';
    let lat = null;
    let lng = null;

    if (hasLatLng) {
      lat = mapLat;
      lng = mapLng;
    }

    const url = `//www.google.com/maps/embed/v1/place?key=${
      x5script.mapsAPIkey
    }&q=${mapAddress}&zoom=${mapZoom}`;

    const iframe = $('<iframe></iframe>', {
      width: '100%',
      height: '100%',
      src: encodeURI(url),
      frameborder: 0,
      center: hasLatLng ? `${lat},${lng}` : '',
    });

    self.html(iframe);
  }

  /**
   * This function will render a Google Map onto the selected DOM element
   * @param mapElement
   * @returns {google.maps.Map}
   */
  static createNewMap(mapElement) {
    const self = $(mapElement);
    const mapZoom = parseFloat(self.attr('data-map-zoom')) || 16;
    const mapLat = parseFloat(self.attr('data-map-lat'));
    const mapLng = parseFloat(self.attr('data-map-lng'));
    const mapInfo = self.parent().find('.js-google-map-info');

    const mapStyle = [
      {
        elementType: 'geometry',
        featureType: 'water',
        stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
      },
      {
        elementType: 'geometry',
        featureType: 'landscape',
        stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
      },
      {
        elementType: 'geometry.fill',
        featureType: 'road.highway',
        stylers: [{ color: '#ffffff' }, { lightness: 17 }],
      },
      {
        elementType: 'geometry.stroke',
        featureType: 'road.highway',
        stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
      },
      {
        elementType: 'geometry',
        featureType: 'road.arterial',
        stylers: [{ color: '#ffffff' }, { lightness: 18 }],
      },
      {
        elementType: 'geometry',
        featureType: 'road.local',
        stylers: [{ color: '#ffffff' }, { lightness: 16 }],
      },
      {
        elementType: 'geometry',
        featureType: 'poi',
        stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
      },
      {
        elementType: 'geometry',
        featureType: 'poi.park',
        stylers: [{ color: '#dedede' }, { lightness: 21 }],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          { visibility: 'on' },
          { color: '#ffffff' },
          { lightness: 16 },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }],
      },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      {
        elementType: 'geometry',
        featureType: 'transit',
        stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
      },
      {
        elementType: 'geometry.fill',
        featureType: 'administrative',
        stylers: [{ color: '#fefefe' }, { lightness: 20 }],
      },
      {
        elementType: 'geometry.stroke',
        featureType: 'administrative',
        stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
      },
    ];

    const mapCenter = { lat: mapLat, lng: mapLng };
    const args = {
      zoom: mapZoom,
      center: mapCenter, // eslint-disable-line no-magic-numbers
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: false,
      styles: mapStyle,
      zoomControl: true,
      mapTypeControl: true,
      streetViewControl: true,
    };

    const googleMap = new google.maps.Map(mapElement, args);

    const marker = new google.maps.Marker({
      position: mapCenter,
      map: googleMap,
    });

    if (mapInfo.length) {
      const infowindow = new google.maps.InfoWindow({
        content: mapInfo.html(),
      });

      marker.addListener('click', () => {
        infowindow.open(googleMap, marker);
      });

      infowindow.open(googleMap, marker);
    }
  }
}

export default new GoogleMaps();



// WEBPACK FOOTER //
// ./src/scripts/modules/google-map.js